/**
 * DependencyInjection
 *
 * @package     croco-fw
 * @author      Yujiro Takahashi <yujiro@cro-co.co.jp>
 */
class DependencyInjection {
    /**
     * コンストラクタ
     *
     * @access public
     * @param  array opts
     * @return void
     */
    constructor() {
        this.objects = new Map();
    }

    /**
     * プロパティ設定
     *
     * @access private
     * @return void
     */
    set(prop, service) {
        Object.defineProperty(this, prop, {
            get: ()=> {
                return service;
            },
            enumerable: true,
            configurable: false
        });
    }

    /**
     * サービスの即時登録
     *
     * @access private
     * @return void
     */
    registr(prop, service) {
        Object.defineProperty(this, prop, {
            get: ()=> {
                if (!this.objects.has(prop)) {
                    let obj = service();
                    this.objects.set(prop, obj);
                }
                return this.objects.get(prop);
            },
            enumerable: true,
            configurable: false
        });
    }
} // class DependencyInjection

export default DependencyInjection;
